import { FormattedMessage } from 'components/shared/Intl';
import { FC } from 'react';

interface ProductEmptyListProps {
  onClearSearchClick: () => void;
}

export const ProductEmptyList: FC<ProductEmptyListProps> = ({ onClearSearchClick }) => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center h-100 p-5">
      <em className="icon text-secondary">search_off</em>
      <h4 className="text-secondary">
        <FormattedMessage id="productSelector.searchInput.notFound.title" />
      </h4>
      <p className="text-secondary text-center my-3">
        <FormattedMessage id="productSelector.searchInput.notFound.subTitle" />
      </p>
      <button type="button" className="btn btn-discreet-secondary" onClick={() => onClearSearchClick()}>
        <FormattedMessage id="productSelector.search.clearSearch" />
      </button>
    </div>
  );
};
